/**
 * msalConfig.js
 * MSAL (Microsoft Authentication Library) bootstrap for the GlobalOps SPA.
 *
 * The two GUIDs below are PUBLIC identifiers (not secrets) — a SPA's bundle
 * inevitably exposes them, and Entra is designed around that. They identify
 * which app + tenant a sign-in is for; the actual auth happens at Microsoft.
 *
 * Tenant + Client IDs from the GAT Entra app registration (Display: GLOBALOps).
 */
import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '9690f7f8-51ee-48ca-ac38-6c665c25815d',
    authority: 'https://login.microsoftonline.com/d68b3858-00ee-48dc-86df-036e6c317cd9',
    // Use the current origin so the same bundle works on localhost:3000 (dev)
    // and on https://ops.globalat.com (prod) without rebuilding. Both origins
    // must be listed as SPA redirect URIs in the Entra app registration:
    //   https://ops.globalat.com/   and   http://localhost:3000/
    // Redirect flow lands on callback.html (the URI registered under the SPA
    // platform in Entra; the app root '/' is NOT registered as SPA). callback.html
    // immediately forwards the auth response hash to the app root, where
    // handleRedirectPromise (index.js) completes sign-in. The token exchange uses
    // this same redirect_uri, so it matches the registered SPA URI. No popup, so
    // none of the cross-window detection Edge was choking on.
    redirectUri: typeof window !== 'undefined' ? window.location.origin + '/callback.html' : '/callback.html',
    // Stay put after processing the auth response instead of navigating back to
    // the initiating URL — simpler and conflict-free with the hash router.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // localStorage keeps the session across browser restarts so staff aren't
    // re-prompted daily; sign-out still clears it. (Was sessionStorage.)
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
